<template>
    <div>
        <v-card style="max-width: 1200px; margin: auto;">
            <s-toolbar dense dark color="#7b7b7b" @save="savePersons()" @close="close()" save close label="Grupos"></s-toolbar>
            <v-container style="max-width: 100%;">
                <v-card-title class="primary--text">Datos Generales</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4" lg="4" md="6" sm="12">
                            <s-text
                                label="Nombre del Grupo"
                                v-model="item.PdgNameGroup"
                                ref="txtNombre"
                            ></s-text>
                        </v-col>

                        <v-col cols="4" lg="4" md="6" sm="12">
                            <s-select-definition
                                label="Estado"
                                v-model="item.PdgStatus"
                                :def="1154"
                            ></s-select-definition>
                        </v-col>
                        <v-col cols="12" lg="2" md="4" sm="12" >
                            <s-select-definition
                                label="Turno"
                                :def="1278"
                                v-model="item.TypeTurn"
                                
                            ></s-select-definition>
                        </v-col>
                    </v-row>
                    <v-row class="pt-4 pb-4 pr-3 pl-3">
                        <h3>Detalle de Grupo</h3>
                        <v-spacer></v-spacer>
                        <v-btn rounded fab x-small @click="addItemGP()"
                            ><i class="fas fa-plus"></i
                        ></v-btn>   
                    </v-row>
                    <v-divider class="mb-3"></v-divider>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="selectedWorker"
                                :items="workerSearchResults"
                                :search-input.sync="workerSearchText"
                                :loading="workerSearchLoading"
                                :filter="() => true"
                                item-text="FullName"
                                return-object
                                clearable
                                hide-no-data
                                no-filter
                                label="Buscar Trabajador"
                                prepend-icon="mdi-magnify"
                                color="#7b7b7b"
                                ref="focusPrsDocument"
                                @change="onWorkerSelected"
                            >
                                <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.FullName }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ item.PrsDocumentNumber }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                                <template v-slot:selection="{ item }">
                                    {{ item.FullName }} ({{ item.PrsDocumentNumber }})
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                            <s-text
                                label="Nombres"
                                v-model.trim="newPerson.PgdName"
                                ref="focusPgdName"
                                :readonly="true"
                            ></s-text>
                        </v-col>
                        <v-col cols="12" md="4">
                            <s-text
                                label="Apellidos"
                                v-model.trim="newPerson.PgdLastName"
                                :readonly="true"
                            ></s-text>
                        </v-col>
                        <!-- <v-col cols="12" lg="3">
                            <s-select-definition
                                label="Rol"
                                :def="1580"
                                v-model="newPerson.PgdRol"
                            ></s-select-definition>
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-data-table
                                dense
                                :headers="headerProductionGroup"
                                :items="itemsDataPG"
                                hide-default-footer
                                :items-per-page="-1"
                                disable-sort
                            >
                                    <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.Line="{ item }">
                                    {{ item.Line + 1 }}
                                </template>
                                <!-- eslint-disable-next-line vue/valid-v-slot -->
                                <template v-slot:item.Actions="{ item }">
                                    <v-btn
                                        @click="clickDeleteItemGP(item)"
                                        x-small
                                        block
                                        rounded
                                        color="error"
                                    >
                                    <v-icon style="font-size: 16px !important"
                                    >mdi-close</v-icon
                                    >
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-container>
        </v-card>
    </div>
</template>

<script>
    import _sProductionGroupService from "@/services/FrozenProduction/FrzProductionGroupService.js";

    export default {
        components:{},
        props:{
            value:{
                required: false,
                default: -1,
            },
            selectGroup:{
                required: false,
                default: Array,
            }
        },
        data() {
            return {
                headerProductionGroup: [
                    { text:"Item", value :"Line"},
                    { text: "Nombre", value: "PgdName"},
                    { text: "Apellidos", value: "PgdLastName"},
                    { text: "DNI", value: "PrsDocumentNumber"},
                    // { text: "ROL", value: "PgdRol"},
                    { text: "Eliminar", value: "Actions" },
                ],
                newPerson: {},
                newPersonDefault: {
                    PgdName             :'',
                    PgdLastName         :'',
                    PrsDocumentNumber   :'',
                    PrsID               :'',
                    NtpID               :'',
                    CtrID               :'',
                    WkrID               :'',
                },
                itemsDataPG:[],
                itemsDeletePG: [],
                item: {},
                PdgNameGroup: '',
                // Worker search properties
                selectedWorker: null,
                workerSearchText: '',
                workerSearchResults: [],
                workerSearchLoading: false,
                workerSearchTimer: null,
            }
        },
        watch:{
            value(){
                this.getdataPersons();
            },
            workerSearchText(newVal) {
                // Debounce: clear any pending timer
                if (this.workerSearchTimer) {
                    clearTimeout(this.workerSearchTimer);
                }
                // Don't search if empty or too short
                if (!newVal || newVal.trim().length < 2) {
                    this.workerSearchResults = [];
                    return;
                }
                // Set loading immediately for responsive UX
                this.workerSearchLoading = true;
                // Debounce 400ms before hitting the API
                this.workerSearchTimer = setTimeout(() => {
                    this.searchWorkersDebounced(newVal.trim());
                }, 400);
            },
        },
        created(){
            this.getdataPersons();
        },
        methods:
        {
            close()
            {
                this.$emit("close");     
            },
            hadReturnPerson(item) {
                if (item != null) {
                    this.newPerson = {
                        ...this.newPerson,
                        PgdName: item.NtpName ? item.NtpName.trim() : '',
                        PgdLastName: (item.NtpPaternalSurname ? item.NtpPaternalSurname.trim() : '') + " " + (item.NtpMaternalSurname ? item.NtpMaternalSurname.trim() : ''),
                        PrsDocumentNumber: item.PrsDocumentNumber || '',
                        PrsID: item.PrsID || '',
                        NtpID: item.NtpID || '',
                        CtrID: item.CtrID || '',
                        WkrID: item.WkrID || ''
                    };
                }
                console.log("Data de Person", item);
                console.log("New Person", this.newPerson);
            },
            searchWorkersDebounced(searchText) {
                _sProductionGroupService.searchWorkers(searchText, this.$fun.getUserID())
                    .then((r) => {
                        if (r.status === 200) {
                            this.workerSearchResults = r.data || [];
                        } else {
                            this.workerSearchResults = [];
                        }
                    })
                    .catch(() => {
                        this.workerSearchResults = [];
                    })
                    .finally(() => {
                        this.workerSearchLoading = false;
                    });
            },
            onWorkerSelected(item) {
                // If no item selected (e.g., cleared), do nothing
                if (!item) return;

                // Build the newPerson object from the selected worker
                const fullNameParts = (item.FullName || '').trim().split(' ');
                const firstName = fullNameParts[0] || '';
                const paternalSurname = fullNameParts[1] || '';
                const maternalSurname = fullNameParts.slice(2).join(' ') || '';

                const candidatePerson = {
                    PgdName: firstName,
                    PgdLastName: (paternalSurname + ' ' + maternalSurname).trim(),
                    PrsDocumentNumber: item.PrsDocumentNumber || '',
                    PrsID: item.PrsID || '',
                    NtpID: item.NtpID || '',
                    CtrID: item.CtrID || '',
                    WkrID: item.WkrID || ''
                };

                // Check if worker is already in another active group
                if (item.CurrentGroupName) {
                    this.$fun.alert(
                        "El trabajador ya está asignado al grupo: " + item.CurrentGroupName +
                        " (Turno: " + (item.CurrentTurnName || 'N/A') + "). " +
                        "¿Desea reasignarlo a este nuevo grupo?",
                        "question"
                    ).then((r) => {
                        if (r.value) {
                            // User confirmed reassignment
                            this.addWorkerToGroup(candidatePerson);
                        }
                        // Clear the autocomplete regardless
                        this.clearWorkerSearch();
                    });
                } else {
                    // No current group, add directly
                    this.addWorkerToGroup(candidatePerson);
                    this.clearWorkerSearch();
                }
            },
            addWorkerToGroup(personData) {
                // Check for duplicates in the current list
                const existPerson = this.itemsDataPG.some(
                    element => element.PrsDocumentNumber === personData.PrsDocumentNumber
                );

                if (existPerson) {
                    this.$fun.alert("Trabajador ya Ingresado", "warning");
                    return;
                }

                if (!personData.PgdName) {
                    this.$fun.alert("Debe ingresar el nombre de un trabajador", "warning");
                    return;
                }

                // Set the newPerson for reference
                this.newPerson = { ...personData };

                // Add to the group
                this.newPerson.SecStatus = 1;
                this.newPerson.UsrCreateID = this.$fun.getUserID();
                this.newPerson.UsrUpdateID = this.$fun.getUserID();
                this.itemsDataPG.push({ ...this.newPerson });
                this.itemsDataPG = this.itemsDataPG.map((item, index) => ({
                    ...item,
                    Line: index,
                }));

                // Reset
                this.newPerson = { ...this.newPersonDefault };
                this.item.PrsDocumentNumber = null;
            },
            clearWorkerSearch() {
                this.selectedWorker = null;
                this.workerSearchText = '';
                this.workerSearchResults = [];
                this.workerSearchLoading = false;
            },
            addItemGP(){
                // Delegate to the shared add method
                this.addWorkerToGroup({ ...this.newPerson });
                this.$refs.focusPgdName.focus();
            },
            
            clickDeleteItemGP(item) {

                let editedIndex = this.itemsDataPG.indexOf(item);
                this.itemsDataPG.splice(editedIndex, 1);
                
                // this.itemsDataPG = this.itemsDataPG.filter(
                //     (x) => {
                //     return x.Line != item.Line
                //     }
                // );
                this.itemsDataPG = this.itemsDataPG.map((item, index) => ({
                    ...item,
                    Line : index ,
                }));

                if(item.PgdID > 0)
                {
                    item.SecStatus = 0;
                    this.itemsDeletePG.push({ ...item} );                    
                }
                
            },  
            
            savePersons() {

                if(this.item.PdgNameGroup == "")
                {
                    this.$fun.alert("Ingrese el nombre", "warning");
                    this.$refs.txtNombre.focus();
                    return;
                }
                
                if(this.itemsDataPG.length <= 0 ){
                    this.$fun.alert("Grupo debe tener Integrantes", "warning");
                    this.$refs.focusPrsDocument.focus();
                    return;
                }
                
                this.itemsDataPGAdd = [...this.itemsDataPG, ...this.itemsDeletePG];
                
                this.item.FrzProductionGroupDetail = this.itemsDataPGAdd;
                this.item.UsrCreateID = this.$fun.getUserID();
                this.item.UsrUpdateID = this.$fun.getUserID();

                this.$fun.alert("Estas seguro de guardar?", "question").then((r) => {
                    if(r.value){
                
                        _sProductionGroupService.save(this.item, this.$fun.getUserID()).then((r) => {
                        if (r.status == 200) {
                            this.$fun.alert("Registrado correctamente", "success");
                            this.$emit("close");

                            this.itemsDataPG = []
                        }
                        });
                    }
                })
            },
            getdataPersons()
            {
                console.log("value ", this.value);
                // this.item = {}
                if(this.value > 0){

                    if(this.selectGroup.length > 0)
                    {   
                        this.item = this.selectGroup[0];
                    }
                    this.itemsDataPG = []
                    
                    
                    _sProductionGroupService.listdetail({ PdgID: this.value }, this.$fun.getUserID())
                    .then((r) => {
                        if (r.status == 200) {
                            r.data.forEach((el, index) => {
                                el.Line = index + 1;
                            });
                            this.itemsDataPG = r.data;
                        }
                    
                    })
                }else{
                    this.item = {};
                    this.itemsDataPG = [];
                }
            }
        }
    }
</script>